import React from 'react';
import styled from '@emotion/styled';
import { Button } from '@mui/material';

const Footer = () => {
  return (
    <Wrapper>
      <h5> &copy; {new Date().getFullYear()} </h5>
      <h5>
        <span> Shan Packaging </span>
        all right reserved. Developed by{' '}
        <Button href='https://www.modevsolutions.com/'>ModevSolutions</Button>
      </h5>
    </Wrapper>
  );
};

const Wrapper = styled.footer`
  height: 5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: var(--clr-black);
  text-align: center;
  span {
    color: var(--clr-red-light-1);
  }
  h5 {
    color: var(--clr-white);
    margin: 0.1rem;

    font-weight: 400;
    text-transform: none;
    line-height: 1.25;
  }
  a {
    color: var(--clr-red-light);
    transition: var(--transition);
  }
  a:hover {
    color: var(--clr-primary-5);
  }

  @media (min-width: 776px) {
    flex-direction: row;
  }
`;

export default Footer;
